export const defaultUserAvatar = require("@/assets/images/defaults/user.png");

export const defaultKeyPicture = require("@/assets/images/defaults/other.png");

export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const bookingColors = [
  "indigo",
  "orange",
  "deep-orange",
  "blue-grey",
  "deep-purple",
  "brown",
  "teal",
  "lime darken-4",
  "teal darken-4",
  "pink darken-4",
  "blue",
  "red darken-4",
  "purple darken 4",
  "deep-purple darken-4",
  "indigo darken-4",
  "blue darken-4",
  "cyan darken-4",
  "teal darken-4",
  "green darken-4",
  "deep-orange darken-4",
  "brown darken-4",
  "blue-grey darken-4",
];

export const phoneNumberRegexes = {
  france: /^(?:\+|00)[\s.-]*33\s*[1-9](?:[\s.-]*\d{2}){4}$/, // +33 6 89 19 48 95
  belgium: /^(?:\+|00)[\s.-]*32\s*[1-9](?:[\s.-]*\d{2}){4}$/, // +32 6 89 19 48 95
  thailand: /^(?:\+|00)[\s.-]*66\s*(?:[\s.-]*\d{2})(?:[\s.-]*\d{3})(?:[\s.-]*\d{4})$/, // +66 86 610 7676
  switzerland: /^(?:\+|00)[\s.-]*41\s*(?:[\s.-]*\d{2})(?:[\s.-]*\d{3})(?:[\s.-]*\d{2}){2}$/, // +41 79 440 34 38
  luxembourg: /^(?:\+|00)[\s.-]*352\s*(?:[\s.-]*\d{3}){3}$/, // +352 661 144 824
  english: /^(?:\+|00)[\s.-]*44\s*[0-9]{8,9}$/, //  +4465551509
  italia: /^([+]39)?((38[{8,9}|0])|(34[{7-9}|0])|(36[6|8|0])|(33[{3-9}|0])|(32[{8,9}]))([\d]{7})$/, // +393399957495
  spain: /^(?:\+|00)[\s.-]*34\s*[0-9]{7}$/, //  +346555150
  us: /^(?:\+|00)[\s.-]*1\s*[0-9](?:[\s.-]*\d{3}){3}$/, // +15558415183
  england: /^(?:\+|00)[\s.-]*44\s*[0-9](?:[\s.-]*\d{3}){3}$/,
  germany: /^(?:\+|00)[\s.-]*49\s*[0-9]{10}$/,
  Autriche: /^(?:\+|00)[\s.-]*43\s*[0-9]\s*(?:[\s.-]*\d{2}){5}$/,
  Danemark: /^(?:\+|00)[\s.-]*45\s*[0-9]{8}$/,
  Finlande: /^((04[0-9]{1})(\s?|-?)|050(\s?|-?)|0457(\s?|-?)|[+]?358(\s?|-?)50|0358(\s?|-?)50|00358(\s?|-?)50|[+]?358(\s?|-?)4[0-9]{1}|0358(\s?|-?)4[0-9]{1}|00358(\s?|-?)4[0-9]{1})(\s?|-?)(([0-9]{3,4})(\s|\-)?[0-9]{1,4})$/gm,
  Greek: /^(?:\+|00)[\s.-]*30\s*[0-9]{10}$/,
  Irlande: /^(?:\+|00)[\s.-]*353\s*[0-9]{9}$/,
  Netherlands: /^(?:\+|00)[\s.-]*31\s*[0-9]{9}$/,
  Portugal: /^(?:\+|00)[\s.-]*351\s*[0-9]{9}$/,
  Argentina: /^(?:\+|00)[\s.-]*54\s*[0-9]{8}$/,
  Brazil: /^(?:\+|00)[\s.-]*55\s*[0-9]{11}$/,
  Japan: /^(?:\+|00)[\s.-]*81\s*[0-9]{10}$/,
  Australia: /^(?:\+|00)[\s.-]*61\s*[0-9]{9}$/,
};

export const ODM_DEFAULT_USER_GROUP_PREFIX: string = "[AUTO] ";
export const SCOPED_GROUP_PREFIX: string = "[ALL] ";
export const CGU_LINK = "https://info-myloby.s3.eu-west-3.amazonaws.com/Myloby_CGV_CGU.pdf";
export const TUTORIALS = [
    "https://www.youtube.com/embed/e3oD4rLRO2U",
    "https://www.youtube.com/embed/c2AdSRAnvSI",
    "https://www.youtube.com/embed/97uxX6FkEDw",
    "https://www.youtube.com/embed/xClRMnqY71A",
    "https://www.youtube.com/embed/YuG4hBE7u8U",
    "https://www.youtube.com/embed/hceu47hOfT8",
  ];

export const ROWS_PER_PAGE = [10, 25, 50];
